<template>
  <div id="app">
    <h1>HOLA</h1>
    <client :client="client"></client>
    <div class="playButton" @click="triggerPlay" v-if="showPlayButton">
      <div>
        Presiona en cualquier lugar para iniciar la reproducción
      </div>
    </div>
    <div class="playbar">
      <div v-text="title"></div>
      <div v-text="artist"></div>
    </div>
  </div>
</template>
<script>
/* eslint-disable */
import Client from '../player/client'
import api from '../player/api'
import audio from '../player/audio'

if (!window.audio) window.audio = new Audio()

export default {
  data () {
    return {
      audio: null,
      title: '',
      artist: '',
      type: 'spot',
      token: -1,
      active: false,
      lastTry: 0,
      client: { color: '', name: '', logo: 'logo.svg', mobile_logo: '' },
      showPlayButton: true
    }
  },

  methods: {
    loadClient () {
      console.log(this.$route.params.channel_name);
      window.audio.pause()
      this.token = -1
      this.audio = null
      this.type = 'spot'

      this.active = false
      if (!this.$route.params.channel_name) return
      this.$http.get(`/client/${this.$route.params.channel_name}`)
        .then(({ data }) => {
          this.client = data
          this.next()
        })
        .catch((err) => {
          if (err.response && err.response.status === 404) {
            console.log('channel not found')
          }
          console.log(err.response.status)
        })
    },

    saveCurrentState () {
      if (!window.audio.paused) {
        window.localStorage.audioState =
          this.token + '|' +
          this.$route.params.id + '|' +
          window.audio.currentTime
      }
      window.audio.pause()
    },

    savedState () {
      if (!localStorage.audioState) return 0
      const state = localStorage.audioState.split('|')
      if (Number(state[0]) === this.token && state[1] === this.$route.params.id) {
        return parseInt(state[2]) || 0
      }
      return 0
    },

    triggerPlay () {
      this.showPlayButton = false
      const promise = window.audio.play()
      if (promise) {
        promise
          .then(() => { this.showPlayButton = false })
          .catch(() => { this.showPlayButton = true })
      }
    },

    next () {
      clearTimeout(window.retry)
      const now = (new Date()).valueOf()
      const diff = now - this.lastTry
      if (diff < 2000) {
        // This makes the next() method available once every 2 seconds
        console.log('Queued for ' + (2000 - diff))
        window.retry = setTimeout(this.next, 2000 - diff)
        return window.retry
      }
      this.lastTry = now

      this.token += 1
      api({stream: this.$route.params.channel_name, token: this.token})
        .then(({ data }) => {
          if (!data.type) throw new Error(data)
          this.token = Number(data.token)
          this.title = data.title
          this.artist = data.artist
          if (data.type !== 'song' && data.type !== 'videosong') {
            this.title = data.title
            this.artist = 'Sonara'
          }

          window.audio.src = audio[data.type](data.file)
          window.audio.currentTime = this.savedState()

          // Play the audio, handle autoplay block with a promise
          const promise = window.audio.play()
          promise
            .then(() => { this.showPlayButton = false })
            .catch(() => { this.showPlayButton = true })

          // setTimeout(() => this.next(), 2100)
        })
        .catch(err => {
          console.log(err)
          clearTimeout(window.retry)
          window.audio.src = ''
          window.retry = setTimeout(this.next, 2000)
          this.token -= 1
        })
    }

  },

  mounted () {
    this.loadClient()
    window.audio.addEventListener('ended', this.next)
    window.audio.addEventListener('error', this.next)
    window.onbeforeunload = this.saveCurrentState
  },

  watch: {
    $route () {
      this.loadClient() // Reload the client if the route changes
    },

    client () {
      document.body.style.backgroundColor = this.client.color
    }
  },

  components: { Client }
}
</script>
<!--
<style lang="stylus">

  .playbar
    position fixed
    z-index 5
    bottom 0
    left 0
    right 0
    width 100vw
    padding .75em 1.25em
    background rgba(0, 0, 0, .45)
    color white
    margin 0 auto
    text-align center

    :nth-child(1)
      font-size 1.1em

    :nth-child(2)
      font-size .9em
      font-weight bold

  .playButton
    position fixed
    background rgba(0, 0, 0, .85)
    display flex
    justify-content center
    align-items center
    cursor pointer
    width 100vw
    height 100vh
    color white
    font-size 2.5em
    font-weight bold
    z-index 10

    div
      width 100%
      max-width 250px
      text-align center

</style>
 -->